import { adminUsersQuery } from 'scenes/Users/AdminUsers/data/queryKeyFactory';

export const POSITIONS = 'Positions';

export const positionsQuery = adminUsersQuery.query(POSITIONS);
export const grids = positionsQuery.grids();
export const mutations = positionsQuery.mutations();
export const remove = mutations.delete();
export const create = mutations.create();
